module.exports = __webpack_public_path__ + "img/arrow-right.f838aec1.svg";